import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { allProducts } from '../../../services/product';
import MobileMenuDrawer from '../../../components/ui/drawers';
import ProductCard from '../../../components/product/product-card';
import AdvancedFilter from './advanced-filter';
import axios from 'axios';

const HomeContent = ({ categories }) => {
  const API = (process.env.REACT_APP_API).replace(/\/api$/, '');
  const selectedType = useSelector((state) => state.typeFilter);

  const [products, setProducts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({});

  // Normalize text: remove accents and lowercase
  const normalizeText = (text = '') =>
    text
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  useEffect(() => {
    loadProducts();
    fetchLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const res = await allProducts();
      setProducts(res.data);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchLocations = async () => {
    try {
      const res = await axios.get(`${API}/api/locations`);
      setLocations(res.data);
    } catch (err) {
      setLocations([]);
    }
  };

  // eslint-disable-next-line no-extend-native
  Number.prototype.format = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  };

  // Responsividade para tipos de propriedade
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // Helper to get location name
  const getLocationName = (product) => {
    return product.neighborhood?.name || product.city?.name || '';
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  // Adiciona CSS para esconder grid antigo e ajustar espaçamento dos cards no mobile
  // Adicione CSS para o novo card marketplace
  return (
    <div className='container-fluid mb-5 home-container'>
      {/* Filtros Avançados com Campo de Busca Integrado */}
      <AdvancedFilter onFilterChange={handleFilterChange} isMobile={isMobile} onSearchChange={setSearchTerm} searchTerm={searchTerm} />

      {/* Header de Tipo Selecionado */}
      <div className="container2 mb-3">
        <div className="home-header-container">
          <i className={`fas home-header-icon ${selectedType === 'imovel' ? 'fa-home' : 'fa-tools'}`}></i>
          <h3 className="home-header-title">
            {selectedType === 'imovel' ? 'Imóveis' : 'Serviços'}
          </h3>
        </div>
      </div>

      {/* FILTRO DE CATEGORIAS (no lugar dos ícones) */}
      <div className="container2 mb-5">
        <div className="category-overflow">      
          {/* Desktop: grid, Mobile: row scroll */}
          {!isMobile ? (
            <div className="category-grid">
              {categories.map((c, idx) => {
                // Mapeia 'imovel' para 'produto' para comparar com tipo da categoria
                const expectedType = selectedType === 'imovel' ? 'produto' : selectedType;
                
                // Filtra apenas categorias do tipo selecionado
                if ((c.type || 'produto') !== expectedType) {
                  return null;
                }
                
                // Conta apenas produtos ativos para cada categoria
                const activeCount = Array.isArray(products)
                  ? products.filter(
                    (p) => (p.category?._id === c._id || p.category === c._id) && p.status === 'active'
                  ).length
                  : 0;
                return (
                  <Link
                    key={c._id}
                    to={`/category/${c._id}`}
                    className="category-link"
                  >
                    <div className="category-filter">
                      <span className="category-name">{c.name}</span>
                      <span className="category-count">
                        {activeCount} produtos
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className="category-scroll">
              {categories.map((c, idx) => {
                // Mapeia 'imovel' para 'produto' para comparar com tipo da categoria
                const expectedType = selectedType === 'imovel' ? 'produto' : selectedType;
                
                // Filtra apenas categorias do tipo selecionado
                if ((c.type || 'produto') !== expectedType) {
                  return null;
                }
                
                // Conta apenas produtos ativos para cada categoria
                const activeCount = Array.isArray(products)
                  ? products.filter(
                    (p) => (p.category?._id === c._id || p.category === c._id) && p.status === 'active'
                  ).length
                  : 0;
                return (
                  <Link
                    key={c._id}
                    to={`/category/${c._id}`}
                    className="category-link"
                  >
                    <div className="category-filter">
                      <span className="category-name-mobile">{c.name}</span>
                      <span className="category-count-mobile">
                        {activeCount} produtos
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* PRODUTOS EM DESTAQUE 
      <div className="products-section-title">
        <h2 className="sponsored-title">
          Anúncios
        </h2>
      </div>*/}
      <div className="container-products">
        {/* MOBILE: Drawer de categorias */}
        {isMobile && (
          <div className="mobile-drawer">
            <MobileMenuDrawer categories={categories} />
          </div>
        )}

        {/* Cards */}
        <div className={`home-row ${isMobile ? 'home-row-mobile' : ''}`}>
              {(() => {
                const filteredProducts = products.filter(p => {
                  // Mapeia 'imovel' para 'produto' e 'servico' para 'servico'
                  const expectedType = selectedType === 'imovel' ? 'produto' : selectedType;
                  
                  // Filtro por tipo
                  if (p.type !== expectedType) {
                    return false;
                  }
                  
                  // Verificar status ativo
                  if (p.status !== 'active') return false;
                  
                  // Filtro de busca por texto
                  if (searchTerm && 
                      !normalizeText(p.name).includes(normalizeText(searchTerm)) && 
                      !normalizeText(p.description).includes(normalizeText(searchTerm))) {
                    return false;
                  }
                  
                  // Filtro por tipo de imóvel
                  if (filters.propertyType && p.propertyType !== filters.propertyType) {
                    return false;
                  }
                  
                  // Filtro por dormitórios
                  if (filters.bedrooms && p.bedrooms !== parseInt(filters.bedrooms)) {
                    return false;
                  }
                  
                  // Filtro por banheiros
                  if (filters.bathrooms && p.bathrooms !== parseInt(filters.bathrooms)) {
                    return false;
                  }
                  
                  // Filtro por garagens
                  if (filters.garages && p.garages !== parseInt(filters.garages)) {
                    return false;
                  }
                  
                  // Filtro por cidade
                  if (filters.city && p.city?._id !== filters.city) {
                    return false;
                  }
                  
                  // Filtro por estado
                  if (filters.state && p.city?.state !== filters.state) {
                    return false;
                  }
                  
                  // Filtro por bairro
                  if (filters.neighborhood && p.neighborhood?._id !== filters.neighborhood) {
                    return false;
                  }
                  
                  // Filtro por faixa de preço
                  if (filters.priceMin && p.price < parseFloat(filters.priceMin)) {
                    return false;
                  }
                  
                  if (filters.priceMax && p.price > parseFloat(filters.priceMax)) {
                    return false;
                  }
                  
                  return true;
                });
                
                return loading ? (
                  <div className="text-center py-5 w-100">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Carregando produtos...</span>
                    </div>
                  </div>
                ) : filteredProducts.length === 0 ? (
                  <div className={isMobile ? "text-center text-muted py-5 w-100" : "text-center text-muted py-5"}>Nenhum produto encontrado.</div>
                ) : (
                  filteredProducts.map((p, i) => (
                    <div key={i} className="product-card-container">
                      <ProductCard
                        product={p}
                        isMobile={isMobile}
                        API={API}
                        showAuthor={true}
                        getLocationName={getLocationName}
                      />
                    </div>
                  ))
                );
              })()}
            </div>
          </div>
    </div>
  );
};

export default HomeContent;
